import { AddressGroup, AddressProducts, Product } from '@mwe/models';

export function checkAddressProductsForAddressGroupUpdates(addressProducts: AddressProducts[], updates: AddressGroup[]) {
  return addressProducts.map(addressProduct => {
    const update = updates.find(update => update.addressCode === addressProduct.address.addressGroup.addressCode);

    if (!update) {
      return addressProduct;
    }

    const products = addressProduct.products.map(p => {
      return {
        ...p,
        address: {
          ...p.address,
          addressGroup: {
            ...update,
            matchedGroup: true,
          },
        },
      } as Product;
    });

    return {
      ...addressProduct,
      address: {
        ...addressProduct.address,
        addressGroup: {
          ...update,
          matchedGroup: true,
        },
      },
      products,
    };
  });
}
